import React from 'react';
import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { messages } from 'lib/i18n';
import { intlSelector } from '../app/selectors/appSelector';
import moment from 'moment';

export class ConnectedIntlProvider extends React.Component {
    constructor(props) {
        super(props);
        // set locale globally
        // we explicitly bundle only `pt-br` locale
        const locale = props.locale === 'pt' ? 'pt-br' : props.locale;
        moment.locale(locale);
    }

    getChildContext() {
        return {
            messages: {
                ...messages
            }
        };
    }

    render() {
        return (
            <IntlProvider {...this.props} />
        );
    }
}

ConnectedIntlProvider.propTypes = {
    locale: React.PropTypes.string
};

ConnectedIntlProvider.contextTypes = {
    messages: React.PropTypes.object
};

ConnectedIntlProvider.childContextTypes = {
    messages: React.PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    const intl = intlSelector(state);
    return {
        ...intl,
        key: intl.locale
    };
};

export default connect(mapStateToProps)(ConnectedIntlProvider);



// WEBPACK FOOTER //
// ./app/IntlProvider.js